module.exports = new __parcel__URL__("user-brand-dark.53b470c6.svg").toString();